
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'AdrenalTumorStage',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/AdrenalTumorStage.vue